import { ResolvableDeliveryDateState } from '@/data/Content/EstimatedDeliveryDates/types';

export const getResolvedDeliveryDate = (
	state: ResolvableDeliveryDateState | undefined
): Date | undefined =>
	state?.status === 'with-date' || state?.status === 'same-day' ? state.deliveryDate : undefined;
